(() => {
  const GIFT_VARIANT_ID = 45246687314099;
  const THRESHOLD_CENTS = 3900; // $39
  const GIFT_QTY = 1;

  let isRunning = false;

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  }

  async function addGift() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: GIFT_QTY })
    });
  }

  async function changeLine(lineKey, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity })
    });
  }

  function findGiftItem(cart) {
    return cart.items.find(i => i.variant_id === GIFT_VARIANT_ID);
  }

  // Refresh cart drawer UI via sections (works on most Online Store 2.0 themes)
  async function refreshCartUI() {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' });
      const sections = await res.json();

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections });
        return;
      }

      const cartDrawerContainer =
        document.querySelector('#CartDrawer') ||
        document.querySelector('#cart-drawer') ||
        document.querySelector('[id*="CartDrawer"]');

      if (cartDrawerContainer && sections['cart-drawer']) {
        cartDrawerContainer.innerHTML = sections['cart-drawer'];
      }

      const bubble = document.querySelector('#cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        bubble.innerHTML = sections['cart-icon-bubble'];
      }
    } catch (e) {
      // If sections aren't available in this theme, the gift will still add,
      // but the drawer may not visually update until next render.
      console.warn('[HEM auto gift] UI refresh failed:', e);
    }
  }

  async function syncGift() {
    if (isRunning) return;
    isRunning = true;

    try {
      const cart = await fetchCart();
      const giftItem = findGiftItem(cart);
      const cartTotal = cart.total_price;

      let changed = false;

      if (cartTotal >= THRESHOLD_CENTS) {
        if (!giftItem) {
          await addGift();
          changed = true;
        } else if (giftItem.quantity !== GIFT_QTY) {
          await changeLine(giftItem.key, GIFT_QTY);
          changed = true;
        }
      } else {
        if (giftItem) {
          await changeLine(giftItem.key, 0);
          changed = true;
        }
      }

      if (changed) {
        await refreshCartUI();
      }
    } catch (e) {
      console.warn('[HEM auto gift] error:', e);
    } finally {
      isRunning = false;
    }
  }

  // ✅ Run on load
  document.addEventListener('DOMContentLoaded', () => setTimeout(syncGift, 200));

  // ✅ KEY FIX: Run AFTER any cart AJAX request finishes (add/change/update)
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
      if (url && url.includes('/cart/') && (url.includes('add') || url.includes('change') || url.includes('update'))) {
        // Give theme a moment to finish its own rendering, then sync
        setTimeout(syncGift, 250);
      }
    } catch (e) {}

    return res;
  };

  // ✅ Also sync when drawer opens (covers themes that render on open)
  document.addEventListener('click', (e) => {
    const el = e.target?.closest('a,button');
    if (!el) return;
    const cls = (el.className || '').toLowerCase();
    const label = (el.getAttribute('aria-label') || el.textContent || '').toLowerCase();
    if (cls.includes('cart') || label.includes('cart')) setTimeout(syncGift, 250);
  });
})();
